var map = {
  "./de.resources.json": "23183",
  "./en.resources.json": "59734",
  "./es.resources.json": "83314",
  "./lt.resources.json": "93191",
  "./pl.resources.json": "59126",
  "./ru.resources.json": "26984",
  "./ua.resources.json": "34688"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15361;
